module.exports = __webpack_public_path__ + "static/media/Square_Roots_Basil_Farm.crop.c61da8e9.jpg";